export default __webpack_public_path__ + "static/media/07_photo.dce3ee5d.jpg";